import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {
  Recipient,
  RecipientCreateRequest,
  RecipientCreateResponse,
  RecipientDetails,
  RecipientUpdateRequest,
  RecipientUpdateResponse
} from '@ms-organization-entities';
import {PriorityPatchRequest, RecipientDependency} from '@primatoo-ms-organization';
import {ApiClientConfig} from '../api-client-config';
import {DataProtectionGovernanceService} from '../interface/data-protection-governance-service';
import {ColumnWithLocalization} from 'it/primatoo/openapi/api/org/schemas/common/ColumnWithLocalization';

@Injectable({
  providedIn: 'root'
})
export class RecipientService extends DataProtectionGovernanceService {
  private readonly endpoint: string;

  constructor(
    @Inject(ApiClientConfig) private config,
    public httpClient: HttpClient
  ) {
    super(httpClient);
    this.endpoint = this.config.endPoint + '/api/org/recipients/';
  }


  public getRecipients(): Observable<Recipient[]> {
    const url = this.endpoint;
    return this.httpClient.get<Recipient[]>(url);
  }

  setPriority(id: number, request: PriorityPatchRequest): Observable<Recipient> {
    const url = `${this.endpoint}${id}/priority`;
    return this.httpClient.patch<Recipient>(url, request);
  }

  public findUserColumns(): Observable<ColumnWithLocalization[]> {
    const url = this.endpoint + `columns`;
    return this.httpClient.get<ColumnWithLocalization[]>(url);
  }

  public getCategories(): Observable<string[]> {
    const url = this.endpoint + `categories/`;
    return this.httpClient.get<string[]>(url);
  }

  // public updateUserColumns(columnsConfigurationUpsertRequest: ColumnsConfigurationUpsertRequest): Observable<void> {
  //   const url = this.endpoint + 'user-columns';
  //   return this.httpClient.post<void>(url, columnsConfigurationUpsertRequest);
  // }

  public getRecipientById(id: number): Observable<Recipient> {
    const url = this.endpoint + id + '/';
    return this.httpClient.get<Recipient>(url);
  }

  public getRecipientDetails(id: number): Observable<RecipientDetails> {
    const url = this.endpoint + id + '/details';
    return this.httpClient.get<RecipientDetails>(url);
  }

  public getRecipientDependencies(id: number): Observable<RecipientDependency> {
    const url = this.endpoint + id + '/dependency';
    return this.httpClient.get<RecipientDependency>(url);
  }

  public deleteRecipient(id: number): Observable<Recipient> {
    const url = this.endpoint + id + '/';
    return this.httpClient.delete<Recipient>(url);
  }

  public createRecipient(requestBody: RecipientCreateRequest): Observable<RecipientCreateResponse> {
    const url = this.endpoint;
    return this.httpClient.post<RecipientCreateResponse>(url, requestBody);
  }

  public updateRecipient(id: number, requestBody: RecipientUpdateRequest): Observable<RecipientUpdateResponse> {
    const url = this.endpoint + id + '/';
    return this.httpClient.put<RecipientUpdateResponse>(url, requestBody);
  }

  getEndPointV1(): string {
    return this.endpoint;
  }

  public exportRaw() {
    const url = this.endpoint + `download`;
    return this.httpClient.get(url, {
      responseType: 'blob',
      observe: 'response'
    });
  }
}
